import * as React from 'react';
import { observer } from 'mobx-react';
import Modal from '../Modal/Modal';
import { Button, Display } from 'Views/Components/Button/Button';
import { BusinessValidation } from '../BusinessNumberInputs/BusinessValidationModel';
import { AbnInput } from '../BusinessNumberInputs/AbnInput';
import { AcnInput } from '../BusinessNumberInputs/AcnInput';

export interface ValidateCustomerProps {
	onAfterChange?: (validateSuccessful: boolean) => void,
	readonly?: boolean,
	onClose: () => void,
}

const ValidateBusinessNumberModal = observer((props: ValidateCustomerProps) => {
	const {
		onClose,
	} = props;

	const [model] = React.useState<BusinessValidation>(new BusinessValidation());

	return (
		<Modal
			isOpen
			label="Validate Business Number"
			onRequestClose={onClose}
			className='validate-business-number-modal'
		>
			<div>
				<h4> Validate a customer</h4>
				<div className="inputs-column stretch" style={{}}>
					<AbnInput model={model} />
				</div>

				<div className="inputs-column stretch">
					<AcnInput model={model} />
				</div>
				<div key="actions" className="modal__actions">
					<Button key="cancel" onClick={onClose} display={Display.Solid}>Close</Button>
				</div>
			</div>
		</Modal>
	);
});

export default ValidateBusinessNumberModal;



